module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MainMenu":{"ariaLabel":"Hlavní menu s podkategoriemi","dropdown":{"categories":"Kategorie","column1":"To nejdráždivější","column2":"Inspirujte se"}}},"en":{"MainMenu":{"ariaLabel":"Main menu with subcategories","dropdown":{"categories":"Category","column1":"Most sexy","column2":"Get inspired"}}}}')
  delete Component.options._Ctor
}
